/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Cameras.Controls
 */

module.exports = {

    Fixed: require('./FixedKeyControl'),
    Smoothed: require('./SmoothedKeyControl')

};



//////////////////
// WEBPACK FOOTER
// ./cameras/controls/index.js
// module id = 467
// module chunks = 0